<template>
    <div @dragover = "onDragover">
        <v-menu
            v-model                 = "menu"
            :close-on-content-click = "false"
            content-class           = "document-menu white"
            z-index                 ="100"
            offset-y
        >
            <template v-slot:activator="{ on, attrs }" >
                <a
                    v-bind = "attrs"
                    v-on   = "on"
                    class  = "step-icon"
                >
                    <v-icon>mdi-paperclip</v-icon>
                    <span class = "mr-1">{{ documents ? documents.length : '0' }}</span>
                    <i
                        class  = "ml-0 pr-2 fas primary--text"
                        :class = "menu?'fa-caret-up ' :'fa-caret-down '"
                    />
                </a>
            </template>

            <c-dms-documents
                class         = "mt-3 ml-5 mr-3"
                :category     = "category"
                :documents    = "filtered"
                :step-data-id = "stepDataId"
                :step-name    = "stepName"
                @context      = "onContext"
                @search       = "onSearch"
            />
        </v-menu>
    </div>
</template>

<script>

// DOC import Inc           from "@/modules/inc/service/Inc";
import Inb           from "@/modules/inb/service/Inb";
import Dms           from "@/modules/dms/common/service/Dms";
import CDmsDocuments from "@/modules/dms/menu/components/CDmsDocuments.vue";
import Core from "@/modules/core/service/Core";

export default {
    name: "CDmsMenuIncident",

    components: {
        CDmsDocuments,
    },

    props: {
        category: {

        },

        stepDataId: {
            required: false,
            type: Number,
        },

        stepName: {

        }
    },

    data: () => ({
        menu     : false,
        filtered : [],
        all      : true
    }),

    computed: {
        incident () {
            return this.$store.getters.incident;
        },

        stepData () {
            if (!this.incident) {
                return null;
            }

            return this.incident.data.find(d => d.id === this.stepDataId);
        },

        documents () {
            if (!this.stepData) {
                return null;
            }

            return this.stepData.documents;
        },

        preferences() {
            return this.$store.getters.preferences;
        },

        unitId () {
            const unit = this.$store.getters.context.site;
            if (!unit) {
                return null;
            }

            return unit;
        },
    },

    created() {
        this.$bus.$on(this.$events.refreshdocuments, this.load);
        this.$bus.$on(Inb.event.refresh, () => {
            this.load();
        });
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.refreshdocuments, this.load);
    },

    mounted() {
      this.load();
    },

    watch: {
        menu: function () {
            if (this.menu) {
                this.load();
            }
        },

        unitId() {
            this.load();
        },
    },

    methods: {
        load() {
            if (!this.stepDataId) {
                return;
            }

            if (this.all) {
                this.filtered = this.documents;
            } else {
                this.filtered = this.documents.filter (d => !d.unitId ||  d.unitId === this.unitId);
            }
        },

        onMenu (menu) {
            this.menu = menu;
        },

        onSelected (document) {
            Dms.open(document.id, document.name);
        },

        onContext (value) {
            this.all = value;
            this.load();
        },

        onSearch (text) {
            if (!text) {
                this.filtered = this.documents;
                return;
            }

            this.filtered = this.documents.filter(d => Core.filter.includes(d.name, text) || Core.filter.includes(d.type.name, text));
        },

        onDragover () {
            this.menu = true;
        },
    }
}

</script>

<style scoped>

.step-icon i {
    font-size: 20px;
}

.document-menu {
    border-radius: 10px!important;
    background-color: white!important;
    width: 560px;
}

</style>